/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Sku_Exists_UnknownInputs */

const vi_error_sku_exists_unknown = /** @type {(inputs: Error_Sku_Exists_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã hàng này đã dùng cho sản phẩm khác. Hãy đặt mã hàng khác.`)
};

/**

* @param {Error_Sku_Exists_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_sku_exists_unknown = /** @type {((inputs?: Error_Sku_Exists_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sku_Exists_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_sku_exists_unknown(inputs)
});